import { ApplicationState } from '../main/types';

export const selectPresignedUrlForImage = (
  state: ApplicationState,
  imageUuid: string,
): string | null => {
  return state.image?.cachedUrls[imageUuid];
};
